module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_6000.6658526d.png";